// PDF Text-Extraktion mit pdf.js
// Für Rewe-PDFs die bereits Text enthalten

import * as pdfjsLib from 'pdfjs-dist';

// Worker separat laden für Performance
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

export async function extractTextFromPDF(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

  let fullText = '';

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const textContent = await page.getTextContent();
    const pageText = textContent.items.map(item => item.str).join(' ');
    fullText += pageText + '\n';
  }

  return fullText.trim();
}

// Prüfen ob die Datei ein PDF ist
export function isPDF(file) {
  return file.type === 'application/pdf' || file.name?.toLowerCase().endsWith('.pdf');
}
